import * as React from 'react'
import styled from 'styled-components'
import { animated } from 'react-spring'

type FirstVideoProps = {
  children: React.ReactElement | React.ReactElement[]
}

const FirstVideoWrapper = ({ children }: FirstVideoProps): JSX.Element | null => (
  <OuterDiv>
    <TitleContainer>
      <LandingTitle>{`The Home of\nVideo NFTs.`}</LandingTitle>
    </TitleContainer>
    <VideoContainer>{children}</VideoContainer>
  </OuterDiv>
)

export default FirstVideoWrapper

const OuterDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* margin: auto; */
  // mobile
  width: calc(100% - 40px);
  /* gap: 25px; */
  max-width: 1800px;

  // tablet
  @media (min-width: 43em) {
    margin: 0 20px;
    /* gap: 50px; */
    /* margin-top: 100px; */
    min-height: 55vh;
  }
  // small desktop
  @media (min-width: 62em) {
    margin-top: 25px;
    min-height: 65vh;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 84%;
  }

  // large desktop
  @media (min-width: 82em) {
    width: 76%;
  }
`

const VideoContainer = styled(animated.div)`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: visible;
  gap: 5px;

  @media (min-width: 43em) {
    width: 100%;
    border-radius: 15px;
  }

  @media (min-width: 62em) {
    width: 55%;
  }
`

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  width: calc(100% - 70px);
  margin-left: 20px;
  margin-right: 20px;
  gap: 15px;

  @media (min-width: 43em) {
    margin: 0;
    width: 100%;
  }

  @media (min-width: 62em) {
    align-items: flex-start;
    justify-content: center;
    background: none;
    padding: 0;
    border: none;
    gap: 25px;
    width: 45%;
  }
`

const LandingTitle = styled.div`
  font-weight: 800;
  text-align: center;
  font-size: 36px;
  line-height: 1.3;
  color: #dcdcdc;

  @media (min-width: 22em) {
    font-size: 36px;
  }

  @media (min-width: 43em) {
    font-size: 48px;
  }

  @media (min-width: 62em) {
    white-space: pre-wrap;
    font-size: 56px;
    text-align: left;
  }

  @media (min-width: 82em) {
    font-size: 64px;
  }

  @media (min-width: 98em) {
    font-size: 80px;
  }
`
